import { get, put, del, post } from 'redux/shelf/api';
import { createReducer } from 'redux/shelf/reducer';
import session from 'lib/session';

export const actions = {
  fetch: get`setup-country-vat-number/${session.getMerchant}`(),
  update: post`setup-country-vat-number/${session.getMerchant}`(),
};

export const reducer = createReducer(actions)
